var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_156_29402",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_156_29402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 23.75V25C7.5 25.3542 7.38021 25.651 7.14062 25.8906C6.90104 26.1302 6.60417 26.25 6.25 26.25H5C4.64583 26.25 4.34896 26.1302 4.10938 25.8906C3.86979 25.651 3.75 25.3542 3.75 25V15L6.375 7.5C6.5 7.125 6.72396 6.82292 7.04688 6.59375C7.36979 6.36458 7.72917 6.25 8.125 6.25H21.875C22.2708 6.25 22.6302 6.36458 22.9531 6.59375C23.276 6.82292 23.5 7.125 23.625 7.5L26.25 15V25C26.25 25.3542 26.1302 25.651 25.8906 25.8906C25.651 26.1302 25.3542 26.25 25 26.25H23.75C23.3958 26.25 23.099 26.1302 22.8594 25.8906C22.6198 25.651 22.5 25.3542 22.5 25V23.75H7.5ZM7.25 12.5H22.75L21.4375 8.75H8.5625L7.25 12.5ZM9.375 20C9.89583 20 10.3385 19.8177 10.7031 19.4531C11.0677 19.0885 11.25 18.6458 11.25 18.125C11.25 17.6042 11.0677 17.1615 10.7031 16.7969C10.3385 16.4323 9.89583 16.25 9.375 16.25C8.85417 16.25 8.41146 16.4323 8.04688 16.7969C7.68229 17.1615 7.5 17.6042 7.5 18.125C7.5 18.6458 7.68229 19.0885 8.04688 19.4531C8.41146 19.8177 8.85417 20 9.375 20ZM20.625 20C21.1458 20 21.5885 19.8177 21.9531 19.4531C22.3177 19.0885 22.5 18.6458 22.5 18.125C22.5 17.6042 22.3177 17.1615 21.9531 16.7969C21.5885 16.4323 21.1458 16.25 20.625 16.25C20.1042 16.25 19.6615 16.4323 19.2969 16.7969C18.9323 17.1615 18.75 17.6042 18.75 18.125C18.75 18.6458 18.9323 19.0885 19.2969 19.4531C19.6615 19.8177 20.1042 20 20.625 20Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.f507bbed1e94aacc349d682e8518d71d.svg";
export { ForwardRef as ReactComponent };